import React,{useState, useEffect} from "react";
import { hot } from "react-hot-loader/root";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Campaings from "./pages/clients/campaings";
import Incart from "./pages/clients/incart";
import Odo_Users from "../src/pages/Users/odoUsers";
import Accept from "../src/pages/odoads_data_manage/accepteduser/Accept";
import AdminRoute from "../src/helpingFiles/AdminRoute/AdminRoute";
import Media from "./pages/media_manage/Media";
import DashBoard from "./pages/DashBoard/DashBoard";
import Login from "./pages/authortication/Login";
import UserProfile from "./Components/userProfile/UserProfile";
import Rejected from "./pages/odoads_data_manage/rejecteduser/Rejected";
import "react-toastify/dist/ReactToastify.css";
import PageNotFound from "./Components/PageNotFound/PageNotFound";
import ProtectRoute from "./Components/Route/ProtectRoute";
import Permission from "./pages/Staff/Permission";
import StaffPermission from "./pages/Staff/StaffPermission";
import "./App.css";
import WebLeads from "./pages/Users/webLeads";
import Order from "./pages/orders/order";
import Users from "./pages/orders/users";
import Revenue from "./pages/orders/revenue";
import Proposals from "./Components/Leads/proposals";
import Audit from "./pages/Auditing/audit";
import Sities from "./pages/Auditing/sities";
import Odoleads from "./pages/Users/odoleads";
import Otherleads from "./pages/Users/otherleads";
import GohBlogs from "./pages/blogs/uploadblog";
import GohBlog from "./pages/blogs/facebookblog";
import Allblog from "./pages/blogs/allblog";
import EditBlogs from "./pages/blogs/editblog";
import Uploadnews from "./pages/news_media/uploadNews";
import Allnews from "./pages/news_media/allNews";
import Editnews from "./pages/news_media/editNews";
import MediaPlanUpload from "./pages/odoads_data_manage/planUpload";

function App() {
const [data,setData] =  useState(false);

const getAddress = () => {
if(localStorage.getItem("admin")){
  setData(true)
}
}

useEffect(() => {
  getAddress()
}, [data]);
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<AdminRoute />}></Route>
          <Route exact path="/login" element={<Login />}></Route> :
          <Route exact path="/dashboard" element={<ProtectRoute Component={DashBoard} />} />
          <Route exact path="/media" element={<ProtectRoute Component={Media} />}/>
          <Route exact path="/webleads" element={<ProtectRoute Component={WebLeads} />}/>  
          <Route exact path="/odoleads" element={<ProtectRoute Component={Odoleads} />}/>
		  <Route exact path="/other" element={<ProtectRoute Component={Otherleads} />}/>  
          <Route exact path="/vanders" element={<ProtectRoute Component={Odo_Users} />}/>  
          <Route exact path="/campaign_sities" element={<ProtectRoute Component={Sities} />}/>  
          <Route exact path="/campaings" element={<ProtectRoute Component={Campaings} />} />
          <Route exact path="/incart" element={<ProtectRoute Component={Incart} />} />
          <Route exact path="/permission" element={<ProtectRoute Component={Permission} />}/>
          <Route exact path="/audit" element={<ProtectRoute Component={Audit} />}/>
          <Route exact path="/order" element={<ProtectRoute Component={Order} />}/>
          <Route exact path="/users" element={<ProtectRoute Component={Users} />}/>
          <Route exact path="/revenue" element={<ProtectRoute Component={Revenue} />}/>
          <Route exact path="/staffPermission" element={<ProtectRoute Component={StaffPermission} />}/>
          <Route exact path="/accept" element={<ProtectRoute Component={Accept} />} />
          <Route exact path="/reject" element={<ProtectRoute Component={Rejected} />}/>
          <Route exact path="/planUpload" element={<ProtectRoute Component={MediaPlanUpload} />}/>
          <Route exact path="/userProfile" element={<ProtectRoute Component={UserProfile} />}/>
          <Route exact path="/proposals_lead/:lead/:id" element={<ProtectRoute Component={Proposals} />}/>
          <Route exact path="/uplodblog" element={<ProtectRoute Component={GohBlogs} />}/>
		  <Route exact path="/facebookblog" element={<ProtectRoute Component={GohBlog} />}/>
          <Route exact path="/allblogs" element={<ProtectRoute Component={Allblog} />}/>
          <Route exact path="/editblog/:id" element={<ProtectRoute Component={EditBlogs} />}/>
          <Route exact path="/uplodnews" element={<ProtectRoute Component={Uploadnews} />}/>
          <Route exact path="/allnews" element={<ProtectRoute Component={Allnews} />}/>
          <Route exact path="/editnews/:id" element={<ProtectRoute Component={Editnews} />}/>
          <Route path="*" element={<PageNotFound />}/>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default hot(App);
